import { hasLoginAccessToken } from '@g/utils/authStorage'

// 淘宝商品详情免登录变体（2026-08-30 后端提供）：除不带登录态外，参数与响应和登录版一致
const GUEST_PRODUCT_DETAIL_URL = '/magicbuy/tb-dg/product/search/product-detail-jutM25Nv9cjf'

const state = {
  list: [],
}

const getters = {
}

const mutations = {
  setList (state, list) {
    state.list = list
  },
}

const actions = {
  productDetail ({ state, commit, rootState }, params) {
    const url = hasLoginAccessToken() ? '/magicbuy/tb-dg/product/search/product-detail' : GUEST_PRODUCT_DETAIL_URL
    return rootState.axios.get(url, {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    }).then(res => {
      const converter = window.OpenCC.Converter({ from: 'cn', to: 'tw' })
      res.data.model = JSON.parse(converter(JSON.stringify(res.data.model)))
      return res
    })
  },
  // 字段名稱參照：https://open.taobao.global/doc/api.htm#/api?cid=21&path=/traffic/item/search&methodType=GET/POST
  searchKeywordQuery ({ state, commit, rootState }, params) {
    return rootState.axios.get('/magicbuy/tb-dg/product/search/keyword-query', {
      params,
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
